<template>
  <div class="table-settings">
    <RedoSetting :isMobile="isMobile" :getPopupContainer="getTableContainer" />
    <SizeSetting :isMobile="isMobile" :getPopupContainer="getTableContainer" />
    <ColumnSetting
      :isMobile="isMobile"
      @columns-change="handleColumnChange"
      :getPopupContainer="getTableContainer"
    />
    <FullScreenSetting
      :isMobile="isMobile"
      :getPopupContainer="getTableContainer"
    />
  </div>
</template>

<script>
import ColumnSetting from "./ColumnSetting.vue";
import SizeSetting from "./SizeSetting.vue";
import RedoSetting from "./RedoSetting.vue";
import FullScreenSetting from "./FullScreenSetting.vue";
export default {
  name: "TableSetting",
  components: { ColumnSetting, SizeSetting, RedoSetting, FullScreenSetting },
  computed: {},
  props: {
    asd: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    // this.getCategory();
  },
  data() {
    return {
      userInfo: {
        name: "admin",
      },
      isMobile: false,
    };
  },
  methods: {},
};
</script>
